export function validEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}
export function validPhoneNumber(str) {
  const regexPhoneNumber = /^((\+)84|0)[1-9](\d{2}){4}$/; 
	return str.match(regexPhoneNumber)
}
export function validInvenCode(value) {
  if (value) {
    const str = value.trim()
    var vn = /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/
    let regex = new RegExp(
      "^[0-9a-zA-Z+-_]{2,50}$"
    );
    
    return regex.test(str) && !vn.test(str);
  }
}
export function validStorageSwitchCode(value) {
  if (value) {
    const str = value.trim()
    var vn = /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/
    const conditions = /^[a-zA-Z0-9\-\_]+$/g
    
    return conditions.test(str) && !vn.test(str);
  }
}
export function validStorageSwitchCodeLength(value) {
  if (value) {
    return value.length >= 6 && value.length <= 50
  }
}
export function validSeria(val) {
  if (val) {
    const str = val.trim()
    var vn = /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/
    const checkVN = vn.test(str)
    const conditions = /^[a-zA-Z0-9\-\_]{3,25}$/g
    return conditions.test(str) && !checkVN
  }
}
export function validSKU(val) {
  if (val) {
    const str = val.trim()
    var vn = /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/
    // const valid = /^[A-Z]+$/g
    return vn.test(str)
  }
}
export function validFormatTransferCode(valOld, valNew) {
  if (valOld.toLowerCase() !== valNew.toLowerCase()) {
    if (valNew && valNew.length > 2) {
      const code = valNew.slice(0,2)
      if (code.toLowerCase() === 'tf') {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
}
export function validExpired(val) {
  if (val) {
    const str = val.trim()
    var vn = /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/
    const checkVN = vn.test(str)
    const conditions = /^[a-zA-Z0-9\-\_]+$/g
    return conditions.test(str) && !checkVN
  }
}